/** Shown in grid cells when the backend sends `null` or `""`. */
export const TABLE_EMPTY_CELL_LABEL = '—';
